module.exports = __webpack_public_path__ + "static/media/route-pro-badge-md.c2402798.svg";